import PayableManagement from './PayableManagement.vue'
export default PayableManagement



// WEBPACK FOOTER //
// ./src/pages/PayableManagement/index.js